import { ListFieldSection } from '../../../../Layout';
import { Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetsResultsMessagesSection } from '../../../Core';

const ResultsSectionBase = (): JSX.Element => (
  <>
    <WorksheetsResultsMessagesSection />
    <ListFieldSection>
      <Field input={<TextOutput />} label="Water Content (%)" name="Results.MoistureContent" />
      <Field input={<TextOutput />} label="Ash Content (%)" name="Results.AshContent" />
      <Field input={<TextOutput />} label="Organic Material (%)" name="Results.OrganicMaterial" />
    </ListFieldSection>
  </>
);

const ResultsSection = withInjectedProps(ResultsSectionBase);

export default ResultsSection;
export { ResultsSection };
